import React, {useRef} from 'react';
import classes from './Tooltip.module.scss';
import ReactTooltip from 'react-tooltip';

const Tooltip = (props) => {
    const reactTooltipRef = useRef(null)

    return (
        <div className={classes.container}>
            <div data-tip data-for={'main' + props.content} className={classes.container}>{props.children}</div>

            <ReactTooltip
                id={'main' + props.content}
                className={classes['tooltipOverride']}

                ref={reactTooltipRef}
                afterShow={evt => {
                    /**
                     * Following function solves tooltip out of screen problem:
                     */
                    const {target} = evt
                    const {tooltipRef} = reactTooltipRef.current

                    if (!tooltipRef) return

                    const targetRect = target.getBoundingClientRect()
                    const rect = tooltipRef.getBoundingClientRect()

                    const overflownLeft = rect.left < 0
                    const overflownRight = rect.right > window.innerWidth

                    if (overflownLeft) {
                        tooltipRef.style.setProperty('left', '10px')
                        tooltipRef.style.setProperty('right', 'auto')
                    } else if (overflownRight) {
                        tooltipRef.style.setProperty('left', 'auto')
                        tooltipRef.style.setProperty('right', '10px')
                    }
                }}

                type={'dark'}
                effect={'solid'}
            >
                {props.content}
            </ReactTooltip>
        </div>
    );
}

export default Tooltip;
